import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"

import { useMeta, useContentfulSection } from "utils"
import { PrimaryNav, AppStickyNav, MobileNav } from "src/components/navigation"
import { Layout, Seo } from "components/common"

import FaxActivateTerms from "src/sections/app/FaxActivateTerms"

const FaxActivate = () => {
  const { fax_activate, app } = useStaticQuery(query)
  const meta = useMeta(fax_activate)

  const { fax_activate_terms } = useContentfulSection(fax_activate.sections)
  const slug = "fax"

  return (
    <StyledComparePage>
      <Layout>
        <Seo {...meta} />

        <MobileNav slug={slug} />
        <div className="light">
          <PrimaryNav slug={slug} />
          <AppStickyNav
            disabled={app.disabled}
            slug={slug}
            salesforceAppexchangeUrl={app.salesforceAppexchangeUrl}
          />

          <FaxActivateTerms {...fax_activate_terms} />
        </div>
      </Layout>
    </StyledComparePage>
  )
}

const StyledComparePage = styled.div`
  .light {
    --section-background-color: var(--lightBG);
    --tg-title-color: var(--card-shade_1);
    --tg-subtitle-color: var(--card-shade_1);
    --nav-sticky-link-color: var(--card-shade_1);
  }
`

export const query = graphql`
  {
    fax_activate: contentfulPage(pageId: { eq: "fax_activate" }) {
      ...Page
    }
    app: contentfulApp(slug: { eq: "fax" }) {
      salesforceAppexchangeUrl
    }
  }
`

export default FaxActivate
